import { Link } from 'react-router-dom';

interface AuctionCardProps {
  id: string;
  title: string;
  currentPrice: number;
  currency: string;
  images: string[];
  endsAt: string;
  bidsCount: number;
  user: {
    firstName: string;
    rating: number;
  };
}

export default function AuctionCard({
  id,
  title,
  currentPrice,
  currency,
  images,
  endsAt,
  bidsCount,
  user
}: AuctionCardProps) {
  const formatPrice = (amount: number, curr: string) => {
    const symbols: Record<string, string> = {
      RUB: '₽',
      KZT: '₸',
      BYN: 'Br'
    };
    return `${amount.toLocaleString('ru-RU')} ${symbols[curr] || curr}`;
  };

  const getTimeLeft = (endDate: string) => {
    const end = new Date(endDate);
    const now = new Date();
    const diff = end.getTime() - now.getTime();

    if (diff <= 0) return 'Завершён';

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    if (days > 0) return `${days}д ${hours}ч`;
    if (hours > 0) return `${hours}ч ${minutes}м`;
    return `${minutes}м`;
  };

  const timeLeft = getTimeLeft(endsAt);
  const isEnding = new Date(endsAt).getTime() - new Date().getTime() < 3600000; // Less than 1 hour

  return (
    <Link to={`/auctions/${id}`} className="block">
      <div className="card hover:opacity-90 transition-opacity">
        <div className="relative aspect-square rounded-lg bg-tg-theme-bg overflow-hidden mb-3">
          {images.length > 0 ? (
            <img
              src={images[0]}
              alt={title}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-4xl text-tg-theme-hint">
              🔨
            </div>
          )}
          
          <div
            className={`absolute top-2 right-2 px-2 py-1 rounded-full text-xs font-medium ${
              isEnding ? 'bg-red-500 text-white' : 'bg-black/50 text-white'
            }`}
          >
            ⏰ {timeLeft}
          </div>
        </div>

        <h3 className="font-medium text-sm line-clamp-2 mb-2">{title}</h3>

        <div className="flex items-center justify-between mb-2">
          <div>
            <p className="text-xs text-tg-theme-hint">Текущая ставка</p>
            <p className="text-lg font-bold text-tg-theme-button">
              {formatPrice(currentPrice, currency)}
            </p>
          </div>
          <div className="text-right">
            <p className="text-xs text-tg-theme-hint">Ставок</p>
            <p className="text-lg font-bold">{bidsCount}</p>
          </div>
        </div>

        <div className="flex items-center text-xs text-tg-theme-hint">
          <span>⭐️ {user.rating.toFixed(1)} • {user.firstName}</span>
        </div>
      </div>
    </Link>
  );
}
